export default "__VITE_ASSET__TZvqG_DK__"